
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12677',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12677",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.479",
  "data-fetching-client": "static-1.9765",
  "foundations-components": "static-1.8130",
  "foundations-components-legacy": "static-1.1155",
  "foundations-theming": "static-1.4531",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8121",
  "hub-http-shared-msw-handlers": "static-1.10208",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11576",
  "I18n": "static-7.1635",
  "jasmine-runner": "static-1.6561",
  "marketplace-storefront-base": "static-1.12740",
  "quartz": "static-1.7157",
  "react-dlb": "static-1.81",
  "react-rhumb": "static-1.16785",
  "reactive-variable-buffer-atom": "static-1.2961",
  "reporting-testing-lib": "static-1.9883",
  "settings-ui-lib": "static-1.12623",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7320",
  "ui-addon-i18n": "static-1.11252",
  "ui-addon-react-router-dom": "static-1.9641",
  "unified-auth": "static-1.611",
  "unified-auth-core-lib": "static-1.893",
  "usage-tracker": "static-1.7451",
  "usage-tracker-core": "static-1.7301",
  "customer-data-property-utils": "static-1.8198",
  "hub-http": "static-1.6324",
  "integrations-lib": "static-1.16479",
  "marketplace-ui-common": "static-1.20111",
  "property-management-iframe": "static-1.13506",
  "quartz-config": "static-1.935",
  "quartz-core": "static-1.6376",
  "quartz-routing": "static-1.587",
  "quick-fetch": "static-1.3992",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4756",
  "ts-schema": "static-1.4155",
  "ui-universal-auth": "static-1.9097",
  "UIComponents": "static-3.8522",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3473",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3434",
  "quartz-webpack": "static-1.3381",
  "bend-plugin-quartz-routing": "static-1.235",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4399",
  "floating-ui": "static-1.57",
  "foundations-assets": "static-1.4974",
  "foundations-theming-specialty": "static-1.2247",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9525",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.33",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5417",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.489",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2177",
  "ui-fonts": "static-1.838",
  "ui-images": "static-2.1177",
  "bend-plugin-foundations-theming": "static-1.3014",
  "foundations-theming-base": "static-1.3516",
  "stylex": "static-1.34",
  "HeadJS": "static-2.766",
  "hs-test-utils-bend-plugin": "static-1.3232",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4429",
  "ai-components-ui-library": "static-1.9204",
  "ai-rendering-library": "static-1.10521",
  "chirp-fetch": "static-1.1989",
  "connections-embed-lib": "static-1.1174",
  "copilot-toolkit": "static-1.11390",
  "feedback-loader": "static-1.29481",
  "laboratory-lib": "static-3.7256",
  "marketplace-embed": "static-1.22406",
  "marketplace-ui-details": "static-1.10006",
  "marketplace-ui-reviews": "static-1.20066",
  "marketplace-ui-tracking": "static-1.14281",
  "sanitize-text": "static-1.8247",
  "ui-addon-video-player": "static-1.8806",
  "usage-tracker-multi": "static-1.5865",
  "usage-tracker-session-replay": "static-1.5137",
  "wootric-nps": "static-1.7058",
  "quartz-head": "static-1.822",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4755",
  "immer": "static-1.33",
  "immerable": "static-1.4254",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2564",
  "reporting-data": "static-1.67950",
  "cssUtils": "static-1.820",
  "flux-actions": "static-1.344",
  "HubStyle": "static-2.11883",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10311",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10465",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7441",
  "icons": "static-2.652",
  "marketplace-ui-apps-core": "static-1.18643",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4615",
  "foundations-components-test-utils": "static-1.5613",
  "quartz-i18n": "static-1.832",
  "react-input-autosize": "static-2.17",
  "ads-unified-auth-lib": "static-1.318",
  "google-sheets-integration-lib": "static-1.529",
  "microsoft-drive-integration-lib": "static-1.665",
  "slack-ui-library": "static-1.10496",
  "fsm": "static-1.3832",
  "customer-data-objects": "static-1.7782",
  "property-translator": "static-1.5500",
  "hs-locale-management": "static-1.157",
  "frontend-preferences-client": "static-1.8029",
  "hs-promise-utils": "static-1.5694",
  "hubspot-apollo-client": "static-1.4981",
  "integrations-error-boundary-lib": "static-1.13894",
  "integrations-tracking-lib": "static-1.5708",
  "native-integrations-shared-strings": "static-1.7886",
  "reselect": "static-2.16",
  "sanitize": "static-1.4579",
  "superstore": "static-1.4863",
  "ui-shepherd-react": "static-3.10326",
  "ai-settings-ui-library": "static-1.8045",
  "hub-http-janus": "static-1.842",
  "hubspotter-http": "static-1.4726",
  "immutable-less": "static-1.4756",
  "marketplace-ui-client-types": "static-1.17518",
  "nav-meta": "static-1.29898",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18134",
  "inbound-db-properties-service-client": "static-1.3920",
  "property-management-common": "static-1.5794",
  "ui-addon-iframeable": "static-1.9167",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.541",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.832",
  "quartz-test": "static-1.832",
  "quartz-tracking": "static-1.536",
  "trellis-components": "static-1.2196",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.166",
  "bender-build-tools": "static-1.3281",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21768",
  "ContentUtils": "static-1.68645",
  "customer-data-objects-ui-components": "static-1.13132",
  "sassPrefix": "static-1.158",
  "breeze-engine-core": "static-1.336",
  "breeze-onboarding-components": "static-1.209",
  "avatar-components": "static-1.2600",
  "customer-data-filters-ui": "static-1.40128",
  "customer-data-reference-ui-components": "static-1.13274",
  "embedded-academy-lib": "static-1.14659",
  "ExportDialog": "static-6.10483",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41554",
  "reporting-snowflake": "static-1.56568",
  "reporting-ui-components": "static-2.65221",
  "reporting-visualizations": "static-1.60026",
  "ui-addon-teams": "static-1.21683",
  "integrations-reconnect-lib": "static-1.147",
  "magpie-lib": "static-1.5618",
  "navigation-components": "static-1.18261",
  "breeze-engine-lib": "static-1.1058",
  "magpie-types": "static-1.5078",
  "simple-logging-lib": "static-1.3153",
  "ai-studio-lib": "static-1.11902",
  "app-governance-lib": "static-1.1870",
  "developer-experience-shared-components": "static-1.10617",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8109",
  "ui-product-approvals": "static-1.28557",
  "ui-tool-access": "static-1.10250",
  "usage-based-billing-components-lib": "static-1.9365",
  "usage-tracker-anonymous": "static-1.5868",
  "usage-tracker-public": "static-1.7262",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3661",
  "persist-promise": "static-1.3802",
  "reference-resolvers": "static-1.8276",
  "ui-extensibility-client-types": "static-1.4027",
  "hubspot-apollo-cache": "static-1.440",
  "universal-page-editor-lib": "static-1.3120",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3057",
  "atom": "static-1.5177",
  "merchandise-lib": "static-1.265",
  "purchase-motions-components": "static-1.6070",
  "salesImages": "static-1.527",
  "batch-promise": "static-1.1645",
  "crm-component-utils": "static-1.39339",
  "crm-properties-common-lib": "static-1.5992",
  "customer-data-properties": "static-1.51917",
  "framework-data-schema-resolvers": "static-1.6992",
  "property-value-citations": "static-1.2531",
  "reference-resolvers-lite": "static-1.8200",
  "ui-business-units-lib": "static-1.9164",
  "navigation-messaging": "static-1.7588",
  "hubspotter-http-shared-msw-handlers": "static-1.10206",
  "base-ui": "static-1.13",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1044",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4916",
  "content-icons-ui": "static-1.2254",
  "customer-data-ui-utilities": "static-1.9928",
  "conversations-skeleton-state": "static-1.7351",
  "crm-message-bus": "static-1.43237",
  "customer-data-filters-ui-msw-helpers": "static-1.22563",
  "events-data-lib": "static-1.334",
  "FormUrlGenerator": "static-2.4824",
  "framework-builder-read-service-client": "static-1.4079",
  "framework-data-schema-quick-fetch": "static-1.6897",
  "multi-account-reference-resolvers": "static-1.1085",
  "onboarding-tours": "static-1.16788",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13962",
  "academy-common-lib": "static-1.14119",
  "content-assistance-lib": "static-1.7912",
  "dashboard-lib": "static-1.81917",
  "file-manager-components": "static-1.23887",
  "getting-started-shared-tasks": "static-1.18687",
  "hubspot-prosemirror": "static-1.18504",
  "hubspot-prosemirror-plugins": "static-1.18496",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20003",
  "share-with-third-party-component-lib": "static-1.8806",
  "ui-addon-draggable": "static-3.4863",
  "ui-asset-management-lib": "static-1.11163",
  "user-context": "static-1.5213",
  "growth-payments-core": "static-1.25669",
  "reporting-plugins": "static-1.10490",
  "reporting-reports": "static-1.67628",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.828",
  "nest": "static-1.335",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10730",
  "framework-listing-lib": "static-2.28973",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30951",
  "apps-service-types": "static-1.3910",
  "oauth-service-types": "static-1.4354",
  "react-dnd-compat": "static-1.4718",
  "ui-product-approvals-common": "static-1.452",
  "onboarding-scopes": "static-1.6562",
  "onboarding-tours-client": "static-1.5002",
  "platform-infra-nav-components": "static-1.7747",
  "subscription-experience-data-types": "static-1.15052",
  "crm-record-cards-service-types": "static-1.3664",
  "location-customization-utils-lib": "static-1.9549",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6073",
  "signup-constants": "static-1.19074",
  "signup-ui-url-generator": "static-2.8159",
  "card-properties-lib": "static-1.44492",
  "commerce-subscription-lib": "static-1.37391",
  "crm-actions": "static-1.6441",
  "crm-cards-sdk": "static-1.43874",
  "customer-data-properties-shared-msw-handlers": "static-1.9535",
  "customer-data-tracking": "static-1.6992",
  "hs-resources": "static-1.276",
  "pulse": "static-1.698",
  "calling-global-api": "static-1.64854",
  "calling-internal-common": "static-1.31413",
  "calling-lifecycle-internal": "static-1.66236",
  "calling-lifecycle-messages": "static-1.58530",
  "commerce-products-lib": "static-1.9909",
  "conditional-properties-service-client": "static-1.3871",
  "crm-links": "static-1.6408",
  "crm-pipelines-api-client-types": "static-1.4213",
  "external-options-client-types": "static-1.4204",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4292",
  "meetings-icalendar-utils-lib": "static-1.737",
  "multi-currency-client-types": "static-1.3765",
  "object-builder-ui-client": "static-1.49087",
  "pipeline-validation-client-types": "static-1.4041",
  "smart-property-lib": "static-1.7718",
  "tiered-pricing": "static-1.1458",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11092",
  "fdsr-migration-layer": "static-1.111",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1128",
  "growth-data-modal": "static-1.5587",
  "growth-onboarding-confetti": "static-1.3168",
  "growth-onboarding-next-action-utils": "static-1.2209",
  "onboarding-tours-utils": "static-1.854",
  "ui-shepherd-tracker": "static-1.7707",
  "academy-service-client": "static-1.3785",
  "SafeStorage": "static-1.4502",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39386",
  "FileManagerLib": "static-1.39527",
  "video-embed": "static-1.36090",
  "ui-coaching-tips": "static-1.28837",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11598",
  "video-data-lib": "static-1.35256",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8559",
  "payment-link-components": "static-1.23776",
  "ui-addon-emoji-picker": "static-1.9989",
  "EmailSignatureEditor": "static-1.24592",
  "viral-links-lib": "static-1.7171",
  "data-token-picker": "static-1.16582",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.326",
  "timezone-utils": "static-2.5345",
  "seat-types-lib": "static-1.245",
  "getting-started-shared-tasks-store": "static-1.17805",
  "ui-addon-opt": "static-4.8463",
  "campaign-roi-lib": "static-1.9382",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25651",
  "framework-data-table": "static-2.12142",
  "marketing-platform-lib": "static-1.6968",
  "nudge-client-utils": "static-1.2791",
  "nudge-custom-ui-functions": "static-1.1205",
  "switchboard-lib": "static-1.325",
  "app-users-service-client": "static-1.5711",
  "app-users-service-types": "static-1.5119",
  "mini-checkout-client": "static-1.27056",
  "onboarding-utils": "static-1.5462",
  "permissions-shared-i18n-strings-fe": "static-1.2061",
  "ui-coaching-tips-shared-config": "static-1.28822",
  "edison-service-client-types": "static-1.491",
  "crm_data": "static-4.92274",
  "customer-data-sidebar": "static-2.46287",
  "enrichment-properties-lib": "static-1.16836",
  "ui-addon-draggable-compat": "static-2.4362",
  "universal-record-utils-lib": "static-1.1194",
  "commerce-billing-lib": "static-1.19397",
  "commerce-shared-components-lib": "static-1.18767",
  "commerce-tools-ui-lib": "static-1.10643",
  "crm-fe-perf": "static-1.23007",
  "event-emitter": "static-1.1053",
  "bend-plugin-pulse": "static-1.201",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31420",
  "shared-worker-versioning": "static-1.11138",
  "calling-usage-tracker": "static-1.6646",
  "voice-sms-access-library": "static-1.1390",
  "commerce-permissions": "static-1.880",
  "products-iframe-lib": "static-1.8210",
  "products-ui-components-shared-msw-handlers": "static-1.10590",
  "data-agent-kit": "static-1.357",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10291",
  "policy-lib": "static-1.6884",
  "react-tinymce": "static-1.55506",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10354",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54632",
  "tinymce-plugins": "static-1.57746",
  "tinymce-themes": "static-1.56602",
  "onboarding-data-sync-lib": "static-1.2131",
  "growth-onboarding-next-action-components": "static-1.2237",
  "user-context-client": "static-1.4684",
  "audio-components": "static-1.6069",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37038",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4639",
  "video-components": "static-1.13600",
  "outpost": "static-1.4273",
  "growth-onboarding-feedback-components": "static-1.6682",
  "content-media-composition-data-lib": "static-1.12625",
  "content-media-compositions": "static-2.16632",
  "media-bridge-lib": "static-1.19098",
  "commerce-tours-lib": "static-1.6282",
  "growth-onboarding-reliability": "static-1.5184",
  "sales-checkout-service-client": "static-1.3694",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21850",
  "sales-email-signature-service-client": "static-1.3951",
  "ts-utils-lib": "static-1.275",
  "crm-export-dialog": "static-1.6388",
  "crm-index-associations-lib": "static-1.6544",
  "crm-view-components": "static-1.575",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7433",
  "nudge-custom-function-registry": "static-1.2548",
  "nudge-renderer-utils": "static-1.2867",
  "whisper-core-api": "static-1.6837",
  "InboxConnectUtils": "static-4.15073",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5767",
  "settings-content-modals": "static-1.46363",
  "crm_universal": "static-1.22182",
  "customer-data-email": "static-1.18210",
  "card-payment-highlight-lib": "static-1.37453",
  "card-subscription-highlight-lib": "static-1.39814",
  "commerce-contract-lib": "static-1.12553",
  "invoices-highlight-card-lib": "static-1.55050",
  "orders-highlight-card-lib": "static-1.21740",
  "products-highlight-card-lib": "static-1.18192",
  "quotes-highlight-card-lib": "static-1.72349",
  "crm-source-interpretation-lib": "static-1.5445",
  "crm-object-search-query-utilities": "static-1.9804",
  "utility-belt": "static-1.2635",
  "payments-enrollment-embed-lib": "static-1.23203",
  "stripe-embedded-components": "static-1.7684",
  "customer-data-rte": "static-1.33257",
  "cv-backend-services": "static-1.1558",
  "growth-onboarding-empty-states": "static-1.5921",
  "payments-post-enroll-local-storage-lib": "static-1.5209",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38439",
  "trials-service-types": "static-1.3983",
  "calling-orchestration-schema": "static-1.36167",
  "sales-views-client-types": "static-1.4358",
  "hub-http-contrib": "static-1.3145",
  "interframe": "static-3.4863",
  "tinymce-data": "static-1.40717",
  "ui-addon-sales-email": "static-1.5313",
  "layout-dnd-components": "static-1.12636",
  "layout-dnd-utils": "static-1.11611",
  "ui-brand-identity-lib": "static-1.15631",
  "NamespacedHubStyle": "static-2.9131",
  "meetings-connect-utils-lib": "static-1.7707",
  "social-insights-client-types": "static-1.22317",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4267",
  "checkout-sdk": "static-3.23899",
  "checkout-service-types": "static-1.3872",
  "company-details-components": "static-1.6300",
  "payment-method-components": "static-1.6977",
  "pricing-pages-ui-components": "static-1.14635",
  "quote-checkout-service-types": "static-1.3565",
  "upgrade-catalog-service-types": "static-1.3624",
  "access-control-lib": "static-1.10537",
  "EmailComponents": "static-1.55041",
  "EmailData": "static-1.53718",
  "redux-less": "static-2.9585",
  "sequences-lib": "static-1.8218",
  "ui-gdpr-components": "static-1.10453",
  "products-ui-components": "static-1.40427",
  "accounting-integrations-ui-components": "static-1.7226",
  "invoices-ui-lib": "static-1.55066",
  "commerce-products-api": "static-1.2438",
  "invoices-iframe-lib": "static-1.57124",
  "quotes-modal-lib": "static-1.103027",
  "quotes-ui-lib": "static-1.81070",
  "stripe-connect-js": "static-1.70",
  "draft-content-plugins": "static-1.28526",
  "ContentData": "static-1.68720",
  "layout-data-lib": "static-1.9936",
  "hub-http-rxjs": "static-1.807",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4040",
  "billing-payments-client-types": "static-1.4093",
  "react-performance-metrics-lib": "static-1.658",
  "account-and-billing-fintech-outages": "static-3.18706",
  "pricing-pages-api": "static-1.14500",
  "ContentComponents": "static-2.71601",
  "marketing-contacts-lib": "static-1.10380",
  "marketing-email-service-types": "static-1.1977",
  "messaging-editing-lib": "static-1.46550",
  "messaging-usage-based-billing-components-lib": "static-1.1412",
  "automation-ui-source-apps": "static-1.19169",
  "automation-ui-types": "static-1.20087",
  "messaging-types-lib": "static-1.46287",
  "onboarding-settings-client": "static-1.4605",
  "sequences-client-types-lib": "static-1.8075",
  "commerce-tax-lib": "static-1.639",
  "price-books-api": "static-1.1195",
  "price-books-components": "static-1.1253",
  "property-description-translator": "static-1.3944",
  "ramp-editor": "static-1.392",
  "commerce-analytics-service-client": "static-1.3682",
  "totals-ui-components": "static-1.23868",
  "SalesContentIndexUI": "static-3.9388",
  "advanced-menus-core": "static-1.15289",
  "advanced-menus-lib": "static-1.12203",
  "ui-memberships-settings-lib": "static-1.34314",
  "segments-query-core": "static-1.1522",
  "automation-ui-ubb": "static-1.6003",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7441",
  "data-token-views": "static-1.16563",
  "forms-utils-lib": "static-1.12769",
  "payments-embed-points-lib": "static-1.13239",
  "simple-menus-core": "static-1.15288",
  "simple-menus-lib": "static-1.16805",
  "videoconference-integration-components": "static-1.6961",
  "marketing-contacts-client": "static-1.7616",
  "automation-applications-service-types": "static-1.3594",
  "automation-platform-service-types": "static-1.2627",
  "ContentEditorUI": "static-2.77385",
  "short-messages-app-service-client": "static-1.4029",
  "web-interactives-components": "static-1.13934",
  "web-interactives-data": "static-1.13935",
  "messaging-shared-utils-lib": "static-1.861",
  "messaging-user-info-utils-lib": "static-1.1031",
  "email-portal-health-service-types": "static-1.1079",
  "line-items-api": "static-1.841",
  "commerce-totals-service-types": "static-1.3893",
  "FireAlarmUi": "static-1.4583",
  "sales-templates-service-types-lib": "static-1.4244",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22023",
  "automation-ui-usage-tracking": "static-1.21486",
  "data-studio-ubb": "static-1.3006",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27247",
  "collaboration-sidebar": "static-1.58130",
  "content-management-data-lib": "static-1.5571",
  "copilot-plugins": "static-1.11363",
  "cta-picker": "static-1.36663",
  "customer-agent-discovery-components-lib": "static-1.3370",
  "editor-components": "static-1.13370",
  "editor-iframe-lib": "static-1.8539",
  "error-messaging-js": "static-1.5294",
  "FormsCommonComponents": "static-1.86111",
  "pictos": "static-7.186",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10748",
  "SharedLegalStrings": "static-1.1847",
  "smart-content-core": "static-1.42710",
  "smart-content-lib": "static-1.43363",
  "social-composer-lib": "static-1.59514",
  "structured-content-lib": "static-1.25452",
  "theme-previewer-lib": "static-1.53513",
  "tinymce-copilot": "static-1.16700",
  "xray-recommendation-lib": "static-1.8038",
  "automation-ui-routing": "static-1.21444",
  "sql-reporting-client-types": "static-1.5716",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42407",
  "campaigns-utils-lib": "static-1.3291",
  "reporting-enablement": "static-1.23267",
  "chatspot-widget-iframe": "static-1.21759",
  "collaboration-sidebar-common": "static-1.2927",
  "forms-ai-lib": "static-1.4475",
  "codemirror-dlb": "static-1.58944",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6538",
  "report-customization-components": "static-1.13437",
  "data-quality-ui-library": "static-1.13292",
  "reporting-filters": "static-1.569",
  "reporting-insights-lib": "static-1.2033"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12677",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.479",
  "data-fetching-client": "/data-fetching-client/static-1.9765",
  "foundations-components": "/foundations-components/static-1.8130",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1155",
  "foundations-theming": "/foundations-theming/static-1.4531",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8121",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10208",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11576",
  "I18n": "/I18n/static-7.1635",
  "jasmine-runner": "/jasmine-runner/static-1.6561",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12740",
  "quartz": "/quartz/static-1.7157",
  "react-dlb": "/react-dlb/static-1.81",
  "react-rhumb": "/react-rhumb/static-1.16785",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2961",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9883",
  "settings-ui-lib": "/settings-ui-lib/static-1.12623",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7320",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11252",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9641",
  "unified-auth": "/unified-auth/static-1.611",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.893",
  "usage-tracker": "/usage-tracker/static-1.7451",
  "usage-tracker-core": "/usage-tracker-core/static-1.7301",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8198",
  "hub-http": "/hub-http/static-1.6324",
  "integrations-lib": "/integrations-lib/static-1.16479",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20111",
  "property-management-iframe": "/property-management-iframe/static-1.13506",
  "quartz-config": "/quartz-config/static-1.935",
  "quartz-core": "/quartz-core/static-1.6376",
  "quartz-routing": "/quartz-routing/static-1.587",
  "quick-fetch": "/quick-fetch/static-1.3992",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4756",
  "ts-schema": "/ts-schema/static-1.4155",
  "ui-universal-auth": "/ui-universal-auth/static-1.9097",
  "UIComponents": "/UIComponents/static-3.8522",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3473",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3434",
  "quartz-webpack": "/quartz-webpack/static-1.3381",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.235",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4399",
  "floating-ui": "/floating-ui/static-1.57",
  "foundations-assets": "/foundations-assets/static-1.4974",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2247",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9525",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.33",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5417",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2177",
  "ui-fonts": "/ui-fonts/static-1.838",
  "ui-images": "/ui-images/static-2.1177",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3014",
  "foundations-theming-base": "/foundations-theming-base/static-1.3516",
  "stylex": "/stylex/static-1.34",
  "HeadJS": "/HeadJS/static-2.766",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3232",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4429",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9204",
  "ai-rendering-library": "/ai-rendering-library/static-1.10521",
  "chirp-fetch": "/chirp-fetch/static-1.1989",
  "connections-embed-lib": "/connections-embed-lib/static-1.1174",
  "copilot-toolkit": "/copilot-toolkit/static-1.11390",
  "feedback-loader": "/feedback-loader/static-1.29481",
  "laboratory-lib": "/laboratory-lib/static-3.7256",
  "marketplace-embed": "/marketplace-embed/static-1.22406",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10006",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20066",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14281",
  "sanitize-text": "/sanitize-text/static-1.8247",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8806",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5865",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5137",
  "wootric-nps": "/wootric-nps/static-1.7058",
  "quartz-head": "/quartz-head/static-1.822",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4755",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4254",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2564",
  "reporting-data": "/reporting-data/static-1.67950",
  "cssUtils": "/cssUtils/static-1.820",
  "flux-actions": "/flux-actions/static-1.344",
  "HubStyle": "/HubStyle/static-2.11883",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10311",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10465",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7441",
  "icons": "/icons/static-2.652",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18643",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4615",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5613",
  "quartz-i18n": "/quartz-i18n/static-1.832",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.318",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.529",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.665",
  "slack-ui-library": "/slack-ui-library/static-1.10496",
  "fsm": "/fsm/static-1.3832",
  "customer-data-objects": "/customer-data-objects/static-1.7782",
  "property-translator": "/property-translator/static-1.5500",
  "hs-locale-management": "/hs-locale-management/static-1.157",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8029",
  "hs-promise-utils": "/hs-promise-utils/static-1.5694",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4981",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13894",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5708",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7886",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4579",
  "superstore": "/superstore/static-1.4863",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10326",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8045",
  "hub-http-janus": "/hub-http-janus/static-1.842",
  "hubspotter-http": "/hubspotter-http/static-1.4726",
  "immutable-less": "/immutable-less/static-1.4756",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17518",
  "nav-meta": "/nav-meta/static-1.29898",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18134",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3920",
  "property-management-common": "/property-management-common/static-1.5794",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9167",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.541",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.832",
  "quartz-test": "/quartz-test/static-1.832",
  "quartz-tracking": "/quartz-tracking/static-1.536",
  "trellis-components": "/trellis-components/static-1.2196",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.166",
  "bender-build-tools": "/bender-build-tools/static-1.3281",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21768",
  "ContentUtils": "/ContentUtils/static-1.68645",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13132",
  "sassPrefix": "/sassPrefix/static-1.158",
  "breeze-engine-core": "/breeze-engine-core/static-1.336",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.209",
  "avatar-components": "/avatar-components/static-1.2600",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40128",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13274",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14659",
  "ExportDialog": "/ExportDialog/static-6.10483",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41554",
  "reporting-snowflake": "/reporting-snowflake/static-1.56568",
  "reporting-ui-components": "/reporting-ui-components/static-2.65221",
  "reporting-visualizations": "/reporting-visualizations/static-1.60026",
  "ui-addon-teams": "/ui-addon-teams/static-1.21683",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.147",
  "magpie-lib": "/magpie-lib/static-1.5618",
  "navigation-components": "/navigation-components/static-1.18261",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1058",
  "magpie-types": "/magpie-types/static-1.5078",
  "simple-logging-lib": "/simple-logging-lib/static-1.3153",
  "ai-studio-lib": "/ai-studio-lib/static-1.11902",
  "app-governance-lib": "/app-governance-lib/static-1.1870",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10617",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8109",
  "ui-product-approvals": "/ui-product-approvals/static-1.28557",
  "ui-tool-access": "/ui-tool-access/static-1.10250",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9365",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5868",
  "usage-tracker-public": "/usage-tracker-public/static-1.7262",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3661",
  "persist-promise": "/persist-promise/static-1.3802",
  "reference-resolvers": "/reference-resolvers/static-1.8276",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4027",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.440",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3120",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3057",
  "atom": "/atom/static-1.5177",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "purchase-motions-components": "/purchase-motions-components/static-1.6070",
  "salesImages": "/salesImages/static-1.527",
  "batch-promise": "/batch-promise/static-1.1645",
  "crm-component-utils": "/crm-component-utils/static-1.39339",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5992",
  "customer-data-properties": "/customer-data-properties/static-1.51917",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6992",
  "property-value-citations": "/property-value-citations/static-1.2531",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8200",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9164",
  "navigation-messaging": "/navigation-messaging/static-1.7588",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10206",
  "base-ui": "/base-ui/static-1.13",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1044",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4916",
  "content-icons-ui": "/content-icons-ui/static-1.2254",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9928",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7351",
  "crm-message-bus": "/crm-message-bus/static-1.43237",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22563",
  "events-data-lib": "/events-data-lib/static-1.334",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4824",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4079",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6897",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1085",
  "onboarding-tours": "/onboarding-tours/static-1.16788",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13962",
  "academy-common-lib": "/academy-common-lib/static-1.14119",
  "content-assistance-lib": "/content-assistance-lib/static-1.7912",
  "dashboard-lib": "/dashboard-lib/static-1.81917",
  "file-manager-components": "/file-manager-components/static-1.23887",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18687",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18504",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18496",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20003",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8806",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4863",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11163",
  "user-context": "/user-context/static-1.5213",
  "growth-payments-core": "/growth-payments-core/static-1.25669",
  "reporting-plugins": "/reporting-plugins/static-1.10490",
  "reporting-reports": "/reporting-reports/static-1.67628",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.828",
  "nest": "/nest/static-1.335",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10730",
  "framework-listing-lib": "/framework-listing-lib/static-2.28973",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30951",
  "apps-service-types": "/apps-service-types/static-1.3910",
  "oauth-service-types": "/oauth-service-types/static-1.4354",
  "react-dnd-compat": "/react-dnd-compat/static-1.4718",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.452",
  "onboarding-scopes": "/onboarding-scopes/static-1.6562",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5002",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7747",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15052",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3664",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9549",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6073",
  "signup-constants": "/signup-constants/static-1.19074",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8159",
  "card-properties-lib": "/card-properties-lib/static-1.44492",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37391",
  "crm-actions": "/crm-actions/static-1.6441",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43874",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9535",
  "customer-data-tracking": "/customer-data-tracking/static-1.6992",
  "hs-resources": "/hs-resources/static-1.276",
  "pulse": "/pulse/static-1.698",
  "calling-global-api": "/calling-global-api/static-1.64854",
  "calling-internal-common": "/calling-internal-common/static-1.31413",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66236",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58530",
  "commerce-products-lib": "/commerce-products-lib/static-1.9909",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3871",
  "crm-links": "/crm-links/static-1.6408",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4213",
  "external-options-client-types": "/external-options-client-types/static-1.4204",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4292",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.737",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3765",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49087",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4041",
  "smart-property-lib": "/smart-property-lib/static-1.7718",
  "tiered-pricing": "/tiered-pricing/static-1.1458",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11092",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.111",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1128",
  "growth-data-modal": "/growth-data-modal/static-1.5587",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3168",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2209",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.854",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7707",
  "academy-service-client": "/academy-service-client/static-1.3785",
  "SafeStorage": "/SafeStorage/static-1.4502",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39386",
  "FileManagerLib": "/FileManagerLib/static-1.39527",
  "video-embed": "/video-embed/static-1.36090",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28837",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11598",
  "video-data-lib": "/video-data-lib/static-1.35256",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8559",
  "payment-link-components": "/payment-link-components/static-1.23776",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9989",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24592",
  "viral-links-lib": "/viral-links-lib/static-1.7171",
  "data-token-picker": "/data-token-picker/static-1.16582",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.326",
  "timezone-utils": "/timezone-utils/static-2.5345",
  "seat-types-lib": "/seat-types-lib/static-1.245",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17805",
  "ui-addon-opt": "/ui-addon-opt/static-4.8463",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9382",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25651",
  "framework-data-table": "/framework-data-table/static-2.12142",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6968",
  "nudge-client-utils": "/nudge-client-utils/static-1.2791",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1205",
  "switchboard-lib": "/switchboard-lib/static-1.325",
  "app-users-service-client": "/app-users-service-client/static-1.5711",
  "app-users-service-types": "/app-users-service-types/static-1.5119",
  "mini-checkout-client": "/mini-checkout-client/static-1.27056",
  "onboarding-utils": "/onboarding-utils/static-1.5462",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2061",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28822",
  "edison-service-client-types": "/edison-service-client-types/static-1.491",
  "crm_data": "/crm_data/static-4.92274",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46287",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16836",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4362",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1194",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19397",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18767",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10643",
  "crm-fe-perf": "/crm-fe-perf/static-1.23007",
  "event-emitter": "/event-emitter/static-1.1053",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.201",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31420",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11138",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6646",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1390",
  "commerce-permissions": "/commerce-permissions/static-1.880",
  "products-iframe-lib": "/products-iframe-lib/static-1.8210",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10590",
  "data-agent-kit": "/data-agent-kit/static-1.357",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10291",
  "policy-lib": "/policy-lib/static-1.6884",
  "react-tinymce": "/react-tinymce/static-1.55506",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10354",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54632",
  "tinymce-plugins": "/tinymce-plugins/static-1.57746",
  "tinymce-themes": "/tinymce-themes/static-1.56602",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2131",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2237",
  "user-context-client": "/user-context-client/static-1.4684",
  "audio-components": "/audio-components/static-1.6069",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37038",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4639",
  "video-components": "/video-components/static-1.13600",
  "outpost": "/outpost/static-1.4273",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6682",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12625",
  "content-media-compositions": "/content-media-compositions/static-2.16632",
  "media-bridge-lib": "/media-bridge-lib/static-1.19098",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6282",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5184",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3694",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21850",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3951",
  "ts-utils-lib": "/ts-utils-lib/static-1.275",
  "crm-export-dialog": "/crm-export-dialog/static-1.6388",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6544",
  "crm-view-components": "/crm-view-components/static-1.575",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7433",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2548",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2867",
  "whisper-core-api": "/whisper-core-api/static-1.6837",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15073",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5767",
  "settings-content-modals": "/settings-content-modals/static-1.46363",
  "crm_universal": "/crm_universal/static-1.22182",
  "customer-data-email": "/customer-data-email/static-1.18210",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37453",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39814",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12553",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55050",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21740",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18192",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72349",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5445",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9804",
  "utility-belt": "/utility-belt/static-1.2635",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23203",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7684",
  "customer-data-rte": "/customer-data-rte/static-1.33257",
  "cv-backend-services": "/cv-backend-services/static-1.1558",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5921",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5209",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38439",
  "trials-service-types": "/trials-service-types/static-1.3983",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36167",
  "sales-views-client-types": "/sales-views-client-types/static-1.4358",
  "hub-http-contrib": "/hub-http-contrib/static-1.3145",
  "interframe": "/interframe/static-3.4863",
  "tinymce-data": "/tinymce-data/static-1.40717",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5313",
  "layout-dnd-components": "/layout-dnd-components/static-1.12636",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11611",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15631",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9131",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7707",
  "social-insights-client-types": "/social-insights-client-types/static-1.22317",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4267",
  "checkout-sdk": "/checkout-sdk/static-3.23899",
  "checkout-service-types": "/checkout-service-types/static-1.3872",
  "company-details-components": "/company-details-components/static-1.6300",
  "payment-method-components": "/payment-method-components/static-1.6977",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14635",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3565",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3624",
  "access-control-lib": "/access-control-lib/static-1.10537",
  "EmailComponents": "/EmailComponents/static-1.55041",
  "EmailData": "/EmailData/static-1.53718",
  "redux-less": "/redux-less/static-2.9585",
  "sequences-lib": "/sequences-lib/static-1.8218",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10453",
  "products-ui-components": "/products-ui-components/static-1.40427",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7226",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55066",
  "commerce-products-api": "/commerce-products-api/static-1.2438",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57124",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103027",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81070",
  "stripe-connect-js": "/stripe-connect-js/static-1.70",
  "draft-content-plugins": "/draft-content-plugins/static-1.28526",
  "ContentData": "/ContentData/static-1.68720",
  "layout-data-lib": "/layout-data-lib/static-1.9936",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.807",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4040",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4093",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.658",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18706",
  "pricing-pages-api": "/pricing-pages-api/static-1.14500",
  "ContentComponents": "/ContentComponents/static-2.71601",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10380",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1977",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46550",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1412",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19169",
  "automation-ui-types": "/automation-ui-types/static-1.20087",
  "messaging-types-lib": "/messaging-types-lib/static-1.46287",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4605",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8075",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.639",
  "price-books-api": "/price-books-api/static-1.1195",
  "price-books-components": "/price-books-components/static-1.1253",
  "property-description-translator": "/property-description-translator/static-1.3944",
  "ramp-editor": "/ramp-editor/static-1.392",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3682",
  "totals-ui-components": "/totals-ui-components/static-1.23868",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9388",
  "advanced-menus-core": "/advanced-menus-core/static-1.15289",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12203",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34314",
  "segments-query-core": "/segments-query-core/static-1.1522",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6003",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7441",
  "data-token-views": "/data-token-views/static-1.16563",
  "forms-utils-lib": "/forms-utils-lib/static-1.12769",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13239",
  "simple-menus-core": "/simple-menus-core/static-1.15288",
  "simple-menus-lib": "/simple-menus-lib/static-1.16805",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6961",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7616",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3594",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2627",
  "ContentEditorUI": "/ContentEditorUI/static-2.77385",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4029",
  "web-interactives-components": "/web-interactives-components/static-1.13934",
  "web-interactives-data": "/web-interactives-data/static-1.13935",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.861",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1031",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1079",
  "line-items-api": "/line-items-api/static-1.841",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3893",
  "FireAlarmUi": "/FireAlarmUi/static-1.4583",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4244",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22023",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21486",
  "data-studio-ubb": "/data-studio-ubb/static-1.3006",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27247",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58130",
  "content-management-data-lib": "/content-management-data-lib/static-1.5571",
  "copilot-plugins": "/copilot-plugins/static-1.11363",
  "cta-picker": "/cta-picker/static-1.36663",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3370",
  "editor-components": "/editor-components/static-1.13370",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8539",
  "error-messaging-js": "/error-messaging-js/static-1.5294",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86111",
  "pictos": "/pictos/static-7.186",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10748",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1847",
  "smart-content-core": "/smart-content-core/static-1.42710",
  "smart-content-lib": "/smart-content-lib/static-1.43363",
  "social-composer-lib": "/social-composer-lib/static-1.59514",
  "structured-content-lib": "/structured-content-lib/static-1.25452",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53513",
  "tinymce-copilot": "/tinymce-copilot/static-1.16700",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8038",
  "automation-ui-routing": "/automation-ui-routing/static-1.21444",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5716",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42407",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3291",
  "reporting-enablement": "/reporting-enablement/static-1.23267",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21759",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2927",
  "forms-ai-lib": "/forms-ai-lib/static-1.4475",
  "codemirror-dlb": "/codemirror-dlb/static-1.58944",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6538",
  "report-customization-components": "/report-customization-components/static-1.13437",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13292",
  "reporting-filters": "/reporting-filters/static-1.569",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2033"
}
};
